export default __webpack_public_path__ + "static/media/repeat.599a9e70.svg";